<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        View update from
        {{ criteria.updatedJbiCriteria.connectPlusDocumentId }}.
      </p>
      <button @click="closeModal" type="button" :class="$style.closeIcon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>
    <section class="modal-card-body">
      <div class="columns">
        <div :class="[`column`, $style.updatedJbiCriteriaNotification]">
          <span>
            All updated criteria will only be available for newly created data
            collection period.
          </span>
        </div>
      </div>
      <div :class="[`column`, $style.initialText]">
        <span>
          Here are the update for your JBI Criteria from
          {{ criteria.updatedJbiCriteria.connectPlusDocumentId }}.
        </span>
      </div>
      <div class="columns">
        <div :class="[`column is-half`]">
          <div :class="$style.criteriaContainer">
            <div :class="$style.criteriaHeader">Your current criteria</div>
            <div :class="$style.criteriaDocumentId">
              {{ criteria.updatedJbiCriteria.currentCriteria.documentId }}
            </div>
            <div :class="$style.criteriaTitle">
              {{ criteria.title }}
            </div>
            <div
              :class="$style.criteriaOptions"
              v-if="criteria.criteriaOptions"
            >
              <template
                v-if="
                  criteria.type === criteriaType.BOOLEAN ||
                  criteria.criteriaType === criteriaType.BOOLEAN
                "
              >
                <div
                  v-for="(booleanOption, index) in criteria.criteriaOptions"
                  :key="`${index}${booleanOption}`"
                >
                  <b-radio
                    disabled
                    native-value="booleanOption"
                    size="is-small"
                    :class="$style.booleanOption"
                  >
                    <span :class="$style.optionText">
                      {{ booleanOption }}
                    </span>
                  </b-radio>
                </div>
              </template>

              <template
                v-if="
                  criteria.type === criteriaType.RANGE ||
                  criteria.criteriaType === criteriaType.RANGE
                "
              >
                <div>Min: {{ criteria.criteriaOptions[0] }}</div>
                <div>Max: {{ criteria.criteriaOptions[1] }}</div>
              </template>

              <template
                v-if="
                  criteria.type === criteriaType.CHECKBOXES ||
                  criteria.criteriaType === criteriaType.CHECKBOXES
                "
              >
                <div
                  v-for="(checkboxesOption, index) in criteria.criteriaOptions"
                  :key="`${index}${checkboxesOption}`"
                >
                  <b-checkbox disabled type="is-info">
                    <span :class="$style.optionText">{{
                      checkboxesOption
                    }}</span>
                  </b-checkbox>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div :class="['column', $style.customeCssChevronRight]">
          <span :class="['icon', $style.iconRight]">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>

        <div :class="[`column is-half`]">
          <div
            v-if="
              criteria.updatedJbiCriteria.status === jbiCriteriaStatus.DELETED
            "
            :class="$style.deletedCriteriaContainer"
          >
            <div :class="$style.deleteCriteriaDetails">
              <div :class="[$style.criteriaHeader, $style.paddingHorizontal]">
                Deleted JBI Criteria
              </div>
              <div
                :class="[$style.criteriaDocumentId, $style.paddingHorizontal]"
              >
                {{ criteria.updatedJbiCriteria.connectPlusDocumentId }}
              </div>
            </div>
            <div :class="$style.deleteCriteriaBox">
              <p :class="$style.deleteCriteriaText">
                This criteria has been deleted
              </p>
            </div>
          </div>

          <div
            v-else-if="
              criteria.updatedJbiCriteria.status === jbiCriteriaStatus.UPDATED
            "
            :class="$style.criteriaContainer"
          >
            <div :class="$style.criteriaHeader">Updated JBI Criteria</div>
            <div :class="$style.criteriaDocumentId">
              {{ criteria.updatedJbiCriteria.connectPlusDocumentId }}
            </div>
            <div :class="$style.criteriaTitle">
              {{ criteria.updatedJbiCriteria.content.title }}
            </div>
            <div :class="$style.criteriaOptions">
              <template
                v-if="
                  criteria.updatedJbiCriteria.content.type ===
                    criteriaType.BOOLEAN &&
                  criteria.updatedJbiCriteria.content.booleanOptions
                "
              >
                <div
                  v-for="(booleanOption, index) in criteria.updatedJbiCriteria
                    .content.booleanOptions"
                  :key="`${index}${booleanOption}`"
                >
                  <b-radio
                    disabled
                    native-value="booleanOption"
                    size="is-small"
                    :class="$style.booleanOption"
                  >
                    <span :class="$style.optionText">
                      {{ booleanOption }}
                    </span>
                  </b-radio>
                </div>
              </template>

              <template
                v-if="
                  criteria.updatedJbiCriteria.content.type ===
                    criteriaType.RANGE &&
                  criteria.updatedJbiCriteria.content.range
                "
              >
                <div>
                  Min:
                  {{ criteria.updatedJbiCriteria.content.range[0] }}
                </div>
                <div>
                  Max:
                  {{ criteria.updatedJbiCriteria.content.range[1] }}
                </div>
              </template>

              <template
                v-if="
                  criteria.updatedJbiCriteria.content.type ===
                    criteriaType.CHECKBOXES &&
                  criteria.updatedJbiCriteria.content.checkboxesOptions
                "
              >
                <div
                  v-for="(checkboxesOption, index) in criteria
                    .updatedJbiCriteria.content.checkboxesOptions"
                  :key="`${index}${checkboxesOption}`"
                >
                  <b-checkbox disabled type="is-info">
                    <span :class="$style.optionText">{{
                      checkboxesOption
                    }}</span>
                  </b-checkbox>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button @click="closeModal" class="button is-primary is-rounded">
        Done
      </button>
    </footer>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  CplusCriteria,
  JBICriteriaStatus,
} from '../../../store/modules/projects/types/projects.types';
import { CRITERION_TYPE } from '../../../store/types/criterions.types';

@Component({})
export default class JbiCriteriaUpdateModal extends Vue {
  @Prop() public criteria!: CplusCriteria;

  public criteriaDetails!: CplusCriteria;

  get criteriaType(): typeof CRITERION_TYPE {
    return CRITERION_TYPE;
  }

  get jbiCriteriaStatus(): typeof JBICriteriaStatus {
    return JBICriteriaStatus;
  }

  public closeModal(): void {
    this.$emit('close');
  }
}
</script>
<style lang="scss" module>
.updatedJbiCriteriaNotification {
  margin: 12px;
  padding: 0.75rem !important;
  background-color: #eff7ff !important;
  border-radius: 4px;

  div > div {
    color: #444f51;
  }

  span {
    font-size: 14px;
    color: #444f51;
  }
}

.initialText {
  font-size: 16px;
  line-height: 22px;
  color: #444f51;
}

.criteriaContainer {
  background: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  padding: 15px;
  height: 100% !important;
}

.criteriaContainer div {
  padding-top: 8px;
}

.criteriaHeader {
  font-weight: 600;
  font-size: 14px;
  color: #444f51;
  text-transform: uppercase;
}

.criteriaDocumentId {
  font-size: 14px;
  color: #9f9f9f;
}

.criteriaTitle {
  font-weight: 500;
  font-size: 14px;
  color: #444f51;
  min-height: 50px;
}

.criteriaOptions {
  padding-bottom: 5px;
  color: #7a7a7a;
}

.optionText {
  display: block;
  font-weight: 500;
  font-size: 14px;
  color: #9e9e9e;
  line-height: 17px;
  text-wrap: nowrap;
}

.deletedCriteriaContainer {
  background-color: #ffedef;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  height: 100% !important;

  div {
    padding-top: 8px;
  }
}

.deleteCriteriaDetails {
  background-color: #ffffff;
  padding-top: 15px !important;
  padding-bottom: 30px !important;
}
.deleteCriteriaBox {
  margin-top: 20px;
  padding: 10px 15px;
  background: #ffedef;
  border-radius: 0px 0px 4px 4px;
}

.deleteCriteriaText {
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #ff465d;
}

.paddingHorizontal {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.closeIcon {
  font-size: 24px;
  background: $white;
  border-radius: 100%;
  color: $grey-3;
  position: relative;
  border: 0;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    color: $primary;
    cursor: pointer;
  }
}

.booleanOption {
  width: 100% !important;
}

.customeCssChevronRight {
  display: flex;
  align-self: center;
  padding: 0;

  .iconRight {
    color: #444f51;
    width: 1px;
    height: 1px;
    font-size: 16px;
  }
}

.tagContainer {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  padding: 0;
}

.tag {
  background: none;
  color: #9a9a9a;
  font-size: 12px;
  padding-right: 15px;
  text-transform: capitalize;
}
</style>
